import { AuthApi } from 'api/AuthApi';
import { JWTUserModel } from 'api/dto/JWTUser.dto';

export class AuthRepository {
  constructor(private authApi: AuthApi) {}

  logged(): Promise<Readonly<JWTUserModel>> {
    return this.authApi.logged();
  }

  resetPasswordRequest({
    email,
    currentCircle,
  }: AuthApi.ResetPasswordRequestParams): Promise<unknown> {
    return this.authApi.resetPasswordRequest({ email, currentCircle });
  }

  logout(): Promise<void> {
    return this.authApi.logout();
  }
}
